import { Card, CardContent } from '@/components/ui/card';
import { TrendingUp, Users, Tv, Award, Medal, Book } from 'lucide-react';

const Stats = () => {
  const stats = [
    {
      icon: <Tv className="w-8 h-8 text-slate-600" />,
      number: '50+',
      label: 'TV Appearances',
      description: 'Featured financial commentator'
    },
    {
      icon: <Medal className="w-8 h-8 text-slate-500" />,
      number: '65M+',
      label: 'Assets Under Management',
      description: 'As of December 2025*'
    },
    {
      icon: <TrendingUp className="w-8 h-8 text-slate-700" />,
      number: '25+',
      label: 'Years of Experience',
      description: 'In financial services'
    },
    {
      icon: <Book className="w-8 h-8 text-slate-800" />,
      number: '3',
      label: 'Books Authored',
      description: 'Including an Amazon best seller'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-4xl font-bold text-center mb-4 text-slate-800">
          At Bridgeriver Advisors, we aim to make the complex simple.
        </h2>
        <p className="text-lg text-center mb-12 text-slate-600">
          A privately owned, registered investment advisory firm headquartered in Michigan, serving clients in applicable states.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <Card key={index} className="text-center p-6 hover:shadow-lg transition-shadow duration-300 border-2 hover:border-slate-300 bg-slate-50">
              <CardContent className="p-0">
                <div className="flex justify-center mb-4">
                  {stat.icon}
                </div>
                <div className="text-3xl font-bold text-slate-800 mb-2">
                  {stat.number}
                </div>
                <div className="text-lg font-semibold text-slate-700 mb-1">
                  {stat.label}
                </div>
                <div className="text-sm text-slate-600">
                  {stat.description}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        <p className="text-xs text-slate-500 text-center mt-6">
          *Assets under management are approximate and subject to change. AUM figures include assets managed across all advisory accounts.
        </p>
      </div>
    </section>
  );
};

export default Stats;
